module.exports = __webpack_public_path__ + "img/book-now.8bb406b8.svg";